import { useContext, useState } from "react";
import { CartContext } from "../context/CartContext";
import "./Checkout.css";

const Checkout = () => {
  const { cart, total } = useContext(CartContext);

  const [form, setForm] = useState({
    name: "",
    phone: "",
    email: "",
    address: "",
  });

  // ================= NEW STATES =================
  const [hasMessage, setHasMessage] = useState(false);
  const [orderMessage, setOrderMessage] = useState("");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handlePayment = () => {
    if (!form.name || !form.phone || !form.email || !form.address) {
      alert("Please fill all fields");
      return;
    }

    const orderData = {
      customer: {
        name: form.name,
        phone: form.phone,
        email: form.email,
        address: form.address,
      },

      items: cart,
      total: Number(total),

      // ================= NEW FIELD =================
      orderMessage: hasMessage ? orderMessage : null,
    };

    localStorage.setItem("orderData", JSON.stringify(orderData));

    window.location.href = "/payment";
  };

  return (
    <div className="checkout-container">

      <h2 className="checkout-title">Checkout</h2>

      {/* FORM */}
      <div className="checkout-form">

        <input
          name="name"
          placeholder="Full Name"
          onChange={handleChange}
          className="checkout-input"
        />

        <input
          name="phone"
          placeholder="Phone Number"
          onChange={handleChange}
          className="checkout-input"
        />

        <input
          name="email"
          placeholder="Email"
          onChange={handleChange}
          className="checkout-input"
        />

        <input
          name="address"
          placeholder="Delivery Address"
          onChange={handleChange}
          className="checkout-input"
        />

        {/* ================= MESSAGE OPTION ================= */}
        <div className="message-toggle">

          <p>Any additional message on your order?</p>

          <div className="toggle-buttons">

            <button
              type="button"
              className={hasMessage ? "active" : ""}
              onClick={() => setHasMessage(true)}
            >
              Yes
            </button>

            <button
              type="button"
              className={!hasMessage ? "active" : ""}
              onClick={() => {
                setHasMessage(false);
                setOrderMessage("");
              }}
            >
              No
            </button>

          </div>

        </div>

        {/* ================= CONDITIONAL TEXT AREA ================= */}
        {hasMessage && (
          <textarea
            placeholder="Write your message here..."
            value={orderMessage}
            onChange={(e) => setOrderMessage(e.target.value)}
            className="checkout-textarea"
          />
        )}

      </div>

      <h3 className="checkout-total">Total: £{total}</h3>

      <button className="checkout-btn" onClick={handlePayment}>
        Proceed to Payment
      </button>

    </div>
  );
};

export default Checkout;